export const PluginTopComponentResources = {
    title: "Z wtyczką <b>nigdy nie zapomnisz</b> o cashbacku!",
    description:
        "Wtyczka goodie cashback to <b>bezpłatne i bezpieczne</b> rozwiązanie, które <b>automatycznie</b> poinformuje Cię o dostępności zwrotów za zakupy online.",
    bonus: "Bonus 10 zł za pierwsze zakupy za min. 40 zł z wtyczką goodie",

    browserLabel: "Wtyczka dostępna dla przeglądarek:",
    browserAdditional:
        "Wtyczka przeznaczona jest wyłącznie na komputery i nie działa obecnie na urządzeniach mobilnych",

    btnActive: "Zainstaluj wtyczkę za darmo",
    btnInactive: "Przeglądarka nie jest obsługiwana",
};
